import React from 'react';
import { Link } from 'react-router-dom';
import airports from '../data/airports';

const AirportTransfers = () => {
  return (
    <section id="airport-transfers" className="at-section">
      <div className="at-container">
        <p className="section-tag">AIRPORT TRANSFERS</p>
        <h2 className="section-heading">Reliable Airport Transfers</h2>
        <div className="at-top">
          <div className="at-image">
            <img src="/images/Airport Transfersslider.jpg" alt="Airport Transfer Service" />
          </div>
          <div className="at-text">
            <p>TAXICABS-247 provides reliable and professional airport transfer services, ensuring a smooth and stress-free journey for every passenger. TAXICABS-247 focuses on punctuality, offering on-time pickups and drop-offs so you never have to worry about missing a flight. With experienced drivers and comfortable vehicles, TAXICABS-247 guarantees a safe and relaxing travel experience.</p>
            <p>Whether you are traveling for business or leisure, TAXICABS-247 makes airport transportation simple, convenient, and dependable. Additionally, TAXICABS-247 monitors flight schedules to adjust pickup times according to delays or early arrivals, ensuring maximum convenience for customers.</p>
          </div>
        </div>
        <div className="airports-grid">
          {airports.map((a, i) => (
            <div key={i} className="airport-card">
              <h4>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"/></svg>
                {a.name}
              </h4>
              <p>{a.desc}</p>
              <Link to={`/airport-details/${a.slug}`} className="service-btn">Read More</Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AirportTransfers;
